module.exports = __webpack_public_path__ + "static/media/ic_wap_3.85691ee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/activitySu/ic_wap_3.svg
// module id = 247
// module chunks = 0